import React from "react";
import useStrings from "../hooks/useStrings";
import Markdown from "react-markdown";

const Services = ({ classicHeader, darkTheme }) => {
  const langStrings = useStrings();

  // services details
  const services = [
    {
      name: langStrings.serviceAnalysisTitle,
      desc: langStrings.serviceAnalysisText,
      icon: "fas fa-lightbulb",
    },
    {
      name: langStrings.serviceDesignTitle,
      desc: langStrings.serviceDesignText,
      icon: "fas fa-database",
    },
    {
      name: langStrings.serviceDevelopmentTitle,
      desc: langStrings.serviceDevelopmentText,
      icon: "fas fa-code",
    },
    {
      name: langStrings.serviceImplementationTitle,
      desc: langStrings.serviceImplementationText,
      icon: "fas fa-rocket",
    },
    {
      name: langStrings.serviceMonitoringTitle,
      desc: langStrings.serviceMonitoringText,
      icon: "fas fa-gauge-high",
    },
    {
      name: langStrings.serviceSupportTitle,
      desc: langStrings.serviceSupportText,
      icon: "fas fa-headset",
    },
    {
      name: langStrings.serviceImprovementsTitle,
      desc: langStrings.serviceImprovementsText,
      icon: "fas fa-gears",
    },
    {
      name: langStrings.serviceAiTitle,
      desc: langStrings.serviceAiText,
      icon: "fas fa-robot",
    },
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            {langStrings.serviceTitle1}
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {langStrings.serviceTitle2}
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        <Markdown>{service.desc}</Markdown>
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
